import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 9AC5919E-2271-42D0-A5FA-ACB9BE022547
 * name lamps
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lamps.svg
 * tags
 * - Home Automation 
 */
export const LampsIcon = createSvgIcon(<><path d="M10 2L12 9H2L4 2M6 10H8V20H11V22H3V20H6V10M20 8L22 15H12L14 8M16 16H18V20H21V22H13V20H16V16Z" /></>, 'LampsIcon');
export default LampsIcon